import { Facebook as FacebookIcon } from "@mui/icons-material";
import { Button, Box, Typography, CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";

import { useAutoLeads } from "0.Mine/1.Hooks/Guides/AutoLeadsSetup";
import { useBusinessContext } from "0.Mine/2.Context/businessContext";
import { SafeArgonBox as ArgonBox } from "0.Mine/4.Argon/ArgonComponents";

const AutomaticLeads = () => {
  const [link, setLink] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(true);
  const { getConnectionLink } = useAutoLeads();
  const { session } = useBusinessContext();

  useEffect(() => {
    const fetchData = async () => {
      if (!session || !session.selectedBusiness) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const response = await getConnectionLink(session.selectedBusiness.id);
        if (response) {
          setLink(response);
        }
      } catch (error) {
        console.error("Error fetching Facebook connection link:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [session]);

  const handleConnectClick = () => {
    if (link) {
      // Define popup dimensions and features
      const width = 600;
      const height = 700;
      const left = window.screen.width / 2 - width / 2;
      const top = window.screen.height / 2 - height / 2;

      // Open the link in a centered popup window
      const popup = window.open(
        link,
        "FacebookConnectPopup",
        `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes,status=yes`
      );

      // Focus the popup window
      if (popup) popup.focus();

      // Optional: Add event listener to detect when the popup closes
      const checkPopupClosed = setInterval(() => {
        if (popup && popup.closed) {
          clearInterval(checkPopupClosed);
          // You can add logic here to refresh data after the connection process
          console.log("Facebook connection popup closed");
          // Optionally refresh the connection status:
          // fetchData();
        }
      }, 500);
    }
  };

  return (
    <ArgonBox
      display="flex"
      flexDirection="column"
      alignItems="center"
      p={3}
      borderRadius="lg"
      bgcolor="grey.100"
    >
      <Typography variant="h5" fontWeight="medium" mb={2}>
        Connessione Lead Automatici Facebook
      </Typography>

      <Typography variant="body2" color="text.secondary" mb={3} textAlign="center">
        Connetti il tuo account Facebook per iniziare a generare lead automatici direttamente dalle
        tue inserzioni.
      </Typography>

      {loading ? (
        <CircularProgress size={30} />
      ) : link ? (
        <Button
          variant="contained"
          color="primary"
          startIcon={<FacebookIcon />}
          onClick={handleConnectClick}
          sx={{
            borderRadius: "10px",
            padding: "10px 20px",
            fontSize: "1rem",
            fontWeight: "bold",
            textTransform: "none",
            boxShadow: "0 4px 10px rgba(59, 89, 152, 0.3)",
            backgroundColor: "#3b5998",
            "&:hover": {
              backgroundColor: "#2d4373",
              boxShadow: "0 6px 15px rgba(59, 89, 152, 0.4)",
            },
            transition: "all 0.3s ease",
          }}
        >
          Connetti con Facebook
        </Button>
      ) : (
        <Typography variant="body2" color="error">
          Non è stato possibile generare il link di connessione. Riprova più tardi.
        </Typography>
      )}

      <Typography variant="caption" color="text.secondary" mt={3} textAlign="center">
        Questo processo è sicuro e ti permetterà di integrare i lead generati da Facebook
        direttamente nella tua dashboard.
      </Typography>
    </ArgonBox>
  );
};

export default AutomaticLeads;
